/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { GameLockModel, GameLockModelType } from './GameLockModel'
import { GameLockModelSelector } from './GameLockModel.base'
import { GameModeTagEnumType } from './GameModeTagEnum'
import { GameSnapshotModel, GameSnapshotModelType } from './GameSnapshotModel'
import { GameSnapshotModelSelector } from './GameSnapshotModel.base'
import { GameStatsModel, GameStatsModelType } from './GameStatsModel'
import { GameStatsModelSelector } from './GameStatsModel.base'
import { TeachingTableModel, TeachingTableModelType } from './TeachingTableModel'
import { TeachingTableModelSelector } from './TeachingTableModel.base'
import { TournamentModel, TournamentModelType } from './TournamentModel'
import { TournamentModelSelector } from './TournamentModel.base'
import { UserGameScheduleModel, UserGameScheduleModelType } from './UserGameScheduleModel'
import { UserGameScheduleModelSelector } from './UserGameScheduleModel.base'
import { RootStoreType } from './index'

/**
 * GameEntityBase
 * auto generated base class for the model GameEntityModel.
 */
export const GameEntityModelBase = ModelBase.named('GameEntity')
  .props({
    __typename: types.optional(types.literal('GameEntity'), 'GameEntity'),
    _id: types.identifier,
    channelName: types.union(types.undefined, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    forPlayers: types.union(types.undefined, types.frozen()),
    hash: types.union(types.undefined, types.string),
    hostId: types.union(types.undefined, types.null, types.frozen()),
    kind: types.union(types.undefined, types.null, GameModeTagEnumType),
    lock: types.union(
      types.undefined,
      types.null,
      types.late(() => GameLockModel)
    ),
    name: types.union(types.undefined, types.null, types.string),
    plain: types.union(types.undefined, types.null, types.string),
    plainBase64: types.union(types.undefined, types.null, types.string),
    snapshot: types.union(
      types.undefined,
      types.late(() => GameSnapshotModel)
    ),
    snapshotCount: types.union(types.undefined, types.number),
    stats: types.union(
      types.undefined,
      types.null,
      types.late(() => GameStatsModel)
    ),
    teachingTable: types.union(
      types.undefined,
      types.null,
      types.late(() => TeachingTableModel)
    ),
    tournament: types.union(
      types.undefined,
      types.null,
      types.late(() => TournamentModel)
    ),
    updatedAt: types.union(types.undefined, types.frozen()),
    userGameSchedule: types.union(
      types.undefined,
      types.null,
      types.late(() => UserGameScheduleModel)
    ),
    users: types.union(types.undefined, types.array(types.string)),
    usersToNotify: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameEntityModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get channelName() {
    return this.__attr('channelName')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get forPlayers() {
    return this.__attr('forPlayers')
  }
  get hash() {
    return this.__attr('hash')
  }
  get hostId() {
    return this.__attr('hostId')
  }
  get kind() {
    return this.__attr('kind')
  }
  get name() {
    return this.__attr('name')
  }
  get plain() {
    return this.__attr('plain')
  }
  get plainBase64() {
    return this.__attr('plainBase64')
  }
  get snapshotCount() {
    return this.__attr('snapshotCount')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get users() {
    return this.__attr('users')
  }
  get usersToNotify() {
    return this.__attr('usersToNotify')
  }
  lock(
    builder: string | GameLockModelSelector | ((selector: GameLockModelSelector) => GameLockModelSelector) | undefined
  ) {
    return this.__child('lock', GameLockModelSelector, builder)
  }
  snapshot(
    builder:
      | string
      | GameSnapshotModelSelector
      | ((selector: GameSnapshotModelSelector) => GameSnapshotModelSelector)
      | undefined
  ) {
    return this.__child('snapshot', GameSnapshotModelSelector, builder)
  }
  stats(
    builder:
      | string
      | GameStatsModelSelector
      | ((selector: GameStatsModelSelector) => GameStatsModelSelector)
      | undefined
  ) {
    return this.__child('stats', GameStatsModelSelector, builder)
  }
  teachingTable(
    builder:
      | string
      | TeachingTableModelSelector
      | ((selector: TeachingTableModelSelector) => TeachingTableModelSelector)
      | undefined
  ) {
    return this.__child('teachingTable', TeachingTableModelSelector, builder)
  }
  tournament(
    builder:
      | string
      | TournamentModelSelector
      | ((selector: TournamentModelSelector) => TournamentModelSelector)
      | undefined
  ) {
    return this.__child('tournament', TournamentModelSelector, builder)
  }
  userGameSchedule(
    builder:
      | string
      | UserGameScheduleModelSelector
      | ((selector: UserGameScheduleModelSelector) => UserGameScheduleModelSelector)
      | undefined
  ) {
    return this.__child('userGameSchedule', UserGameScheduleModelSelector, builder)
  }
}
export function selectFromGameEntity() {
  return new GameEntityModelSelector()
}

export const gameEntityModelPrimitives =
  selectFromGameEntity()._id.channelName.createdAt.forPlayers.hash.hostId.kind.name.plain.plainBase64.snapshotCount
    .updatedAt.users.usersToNotify
